/* eslint-disable jsx-a11y/anchor-is-valid */
import useAxiosPrivate from "../../../../libs/useAxiosPrivate";
import React,{FC, useEffect, useState} from "react";
import { KTIcon } from "../../../../../_metronic/helpers";
import { IssueAreaModel } from '../core/_models';
import { getList } from '../core/_request';
import { useNavigate, useLocation  } from 'react-router-dom';
import { useAuth } from "../../../../modules/auth";

const IssueAreasTable: FC =  () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [issues, setIssues] = useState<Array<IssueAreaModel> | null>(null)
  const axiosPrivate = useAxiosPrivate()
  const {auth} = useAuth()

  useEffect(() => {
    getList(axiosPrivate).then(res=>{
      setIssues(res.data.data)
    }).catch(e=>{
      console.error(e)
      navigate("/auth/login", {state:{from:location}, replace:true})
    })
  }, [axiosPrivate, location, navigate])

  const issueHTML = issues?.map((issue, idx)=>{
    return (
      <tr key={idx}>
        <td>
          {issue.unique_code}
        </td>
        <td>
          {issue.heading}
        </td>
        <td>
          {issue.description}
        </td>
        <td>
          {issue.divider}
        </td>
        <td>
          {issue.upcoming_flag}
        </td>
        <td>
          {issue.status}
        </td>
        <td>
          Action
        </td>
      </tr>
    )
  })


  return (
    <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
      {/* begin::Table head */}
      <thead>
        <tr className='fw-bold text-muted'>
          <th className='min-w-150px'>Code</th>
          <th className='min-w-140px'>Heading</th>
          <th className='min-w-120px'>Description</th>
          <th className='min-w-120px'>Divider</th>
          <th className='min-w-120px'>Upcoming Flag</th>
          <th className='min-w-120px'>Status</th>
          <th className='min-w-100px text-end'>Actions</th>
        </tr>
      </thead>
      {/* end::Table head */}
      {/* begin::Table body */}
      <tbody>
        {/* <tr>
          <td>
            <div className='form-check form-check-sm form-check-custom form-check-solid'>
              <input className='form-check-input widget-13-check' type='checkbox' value='1' />
            </div>
          </td>
          <td>
            <a href='#' className='text-dark fw-bold text-hover-primary fs-6'>
              56037-XDER
            </a>
          </td>
          <td>
            <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
              Brasil
            </a>
            <span className='text-muted fw-semibold text-muted d-block fs-7'>Code: PH</span>
          </td>
          <td>
            <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
              05/28/2020
            </a>
            <span className='text-muted fw-semibold text-muted d-block fs-7'>Code: Paid</span>
          </td>
          <td>
            <a href='#' className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6'>
              Intertico
            </a>
            <span className='text-muted fw-semibold text-muted d-block fs-7'>
              Web, UI/UX Design
            </span>
          </td>
          <td className='text-dark fw-bold text-hover-primary fs-6'>$3560</td>
          <td>
            <span className='badge badge-light-success'>Approved</span>
          </td>
          <td className='text-end'>
            <a
              href='#'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='switch' className='fs-3' />
            </a>
            <a
              href='#'
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
            >
              <KTIcon iconName='pencil' className='fs-3' />
            </a>
            <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
              <KTIcon iconName='trash' className='fs-3' />
            </a>
          </td>
        </tr> */}
        {issueHTML}
      </tbody>
      {/* end::Table body */}
    </table>
  )
}

export default IssueAreasTable